import { render } from "./DeletexIcon.vue?vue&type=template&id=3c709344&ts=true"
import script from "./DeletexIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeletexIcon.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/DeletexIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c709344"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c709344', __exports__)) {
    api.reload('3c709344', __exports__)
  }
  
  module.hot.accept("./DeletexIcon.vue?vue&type=template&id=3c709344&ts=true", () => {
    api.rerender('3c709344', render)
  })

}


export default __exports__